import React, { useState, useEffect } from 'react';
import './ProxyLogs.css';

const ProxyLogs = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedLog, setSelectedLog] = useState(null);
    const API_BASE_URL = import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || 'http://localhost:3003/api/v1';

    useEffect(() => {
        fetchLogs();
        const interval = setInterval(fetchLogs, 5000); // Auto-refresh every 5s
        return () => clearInterval(interval);
    }, []);

    const fetchLogs = async () => {
        try {
            const res = await fetch(`${API_BASE_URL}/soap-history?limit=50`);
            const data = await res.json();
            setLogs(data.data);
            setLoading(false);
        } catch (err) {
            console.error('Failed to fetch logs:', err);
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString();
    };

    const formatDuration = (ms) => {
        if (!ms) return '-';
        return `${ms}ms`;
    };

    const formatXml = (xml) => {
        if (!xml) return '';
        // Basic formatting for display
        return xml;
    };

    return (
        <>
            <header className="top-header">
                <div className="breadcrumb">
                    <span>Monitoring</span>
                    <span className="breadcrumb-separator">/</span>
                    <span className="breadcrumb-current">API Logs</span>
                </div>
            </header>
            <div className="proxy-logs-container">
                <div className="logs-header">
                    <h2>Proxy Audit Logs</h2>
                    <p>Real-time log of all SOAP requests proxied through Titan.</p>
                </div>

                <div className="logs-table-container">
                    <table className="logs-table">
                        <thead>
                            <tr>
                                <th>Timestamp</th>
                                <th>Vendor</th>
                                <th>Operation</th>
                                <th>Status</th>
                                <th>Duration</th>
                                <th>Endpoint</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="6" style={{ textAlign: 'center' }}>Loading...</td></tr>
                            ) : logs.length === 0 ? (
                                <tr><td colSpan="6" style={{ textAlign: 'center' }}>No logs found</td></tr>
                            ) : (
                                logs.map(log => (
                                    <tr key={log.id} onClick={() => setSelectedLog(log)}>
                                        <td>{formatDate(log.created_at)}</td>
                                        <td>{log.vendor}</td>
                                        <td>{log.operation}</td>
                                        <td>
                                            <span className={`status-badge ${log.success ? 'status-success' : 'status-failed'}`}>
                                                {log.success ? 'Success' : 'Failed'}
                                            </span>
                                        </td>
                                        <td>{formatDuration(log.duration_ms)}</td>
                                        <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {log.endpoint}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {selectedLog && (
                    <div className="modal-overlay" onClick={() => setSelectedLog(null)}>
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <div className="modal-header">
                                <h3>Log Details - {selectedLog.operation}</h3>
                                <button className="close-btn" onClick={() => setSelectedLog(null)}>&times;</button>
                            </div>
                            <div className="modal-body">
                                <div className="detail-section" style={{ gridColumn: '1 / -1' }}>
                                    <h4>General Information</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                                        <div>
                                            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#9ca3af', marginBottom: '4px' }}>ENDPOINT</label>
                                            <div style={{ color: '#818cf8', fontFamily: 'monospace', background: 'rgba(99, 102, 241, 0.1)', padding: '4px 8px', borderRadius: '4px', wordBreak: 'break-all', fontSize: '13px' }}>
                                                {selectedLog.endpoint}
                                            </div>
                                        </div>
                                        <div>
                                            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#9ca3af', marginBottom: '4px' }}>TIMESTAMP</label>
                                            <div style={{ color: '#f3f4f6', fontSize: '14px' }}>{formatDate(selectedLog.created_at)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="detail-section">
                                    <h4>Request Data</h4>
                                    <pre className="code-block">
                                        {selectedLog.request_data?.rawXml || JSON.stringify(selectedLog.request_data, null, 2)}
                                    </pre>
                                </div>
                                <div className="detail-section">
                                    <h4>Response Data</h4>
                                    <pre className="code-block">
                                        {selectedLog.response_data?.rawXml || JSON.stringify(selectedLog.response_data, null, 2)}
                                    </pre>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ProxyLogs;
